import notifications from "@/apis/notifications";

const state = () => ({
  unreadCount: 0,
  unreadInformationRequests: 0,
});

const getters = {
  getNotificationsCount(state) {
    return state.unreadCount;
  },

  getInformationRequestsCount(state) {
    return state.unreadInformationRequests;
  },
};

const mutations = {
  setNotifications(state, count) {
    state.unreadCount = count;
  },

  setInformationRequests(state, count) {
    state.unreadInformationRequests = count;
  },

  removeNotification(state) {
    if (state.unreadCount > 0) {
      state.unreadCount--;
    }
  },

  removeAll(state) {
    state.unreadCount = 0;
  },
};

const actions = {
  async refresh({ commit }) {
    const response = await notifications.totalNotifications();

    commit("setNotifications", response.unread_count);
    commit("setInformationRequests", response.unread_information_requests);
  },

  async dismiss({ commit }, notification) {
    commit("removeNotification", notification);

    await notifications.dismiss(notification.id);
  },

  async dismissAll({ commit }, payload) {
    await notifications.dismissAll(payload);
    commit("removeAll");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
